import React, { useEffect, useState } from "react";
import {  Navbar, Offcanvas, Button, Modal} from "react-bootstrap";
import AutenticationService from "../services/Authentication.service";
import SidebarComponent from "../components/SidebarComponent";
import * as constans from "../constants/Constants"
import ChatComponent from "../components/ChatComponent";
import LocalStorageManager from "../services/LocalStorageManager.service";
import ModalComponent from '../components/ModalComponent'
import LoginSingle from "./LoginSingle";
import UpgradeComponent from "../components/UpgradeComponent";
import { useLocation } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import UseApiService from '../services/Api.service'

import toast, { Toaster } from 'react-hot-toast';

export default function MainPage (){  
  const [showSidebar, setShowSidebar] = useState(false);
  const toggleSidebar = () => setShowSidebar(!showSidebar);
  const [isSuscriber,setIsSuscriber] = useState(false);
  const [messages,setMessages] = useState([]);
  const [mensajeChat,setMensajeChat]= useState(null);
  const [listaHistorial,setListaHistorial] = useState([]);
  const [mensajeInicial,setMensajeInicial] = useState([]);
  const [noticiasHoy,setNoticiasHoy] = useState([]);
  const [loading,setLoading] = useState(false);
  const [conversationSessionId, setConversationSessionId] = useState(null);

  
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchByParam = queryParams.get('q');
  const navigate = useNavigate(); 

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [modalTitle, setModalTitle] = useState('Descubre las noticias, una pregunta a la vez');

  const [ppid,setPPID] = useState(LocalStorageManager.getItem('s_ppid')??'');

  const handleChange = (mensaje) => {

    const url = constans.C_API_PPID;
    setLoading(true);
    UseApiService(url,{method:'GET'})
    .then(({data,error}) =>{
      if(error){    
        let err = 'Ocurrio un error: ' + error;
        console.log(err);
        toast.error(err);
      }
      else{
        if(data.msg=='ok'&&data.continue){
          setMensajeChat(mensaje);
        }        
        if(!data.continue){
          if(data.code=='1'){
            setModalTitle(data.msg);
            openModal1();
          }
          if(data.code=='2'){
            setModalTitle(data.msg);
            openModal2();
          }
          
        }
      }
    })
    .catch((e)=>{
      console.log(e);
    })
    .finally((e)=>{
      setLoading(false);      
    }); 
    
    setShowSidebar(false);    
  }

  const handelChangeButton = () => {    
    getDataHoy();
    setMessages([]);
    setConversationSessionId(null);
    setShowSidebar(false);    
  }

  useEffect(()=>{            
    if(!AutenticationService.getIsLogged()){
      checkLogin();
    }

    if(searchByParam){      
      setTimeout(() => {
        handleChange({texto:searchByParam,isUser:true});        
      }, 200);
    }
    else{
      getDataHoy();
    }
    
  },[]);

  useEffect(()=>{
    if(mensajeChat?.texto){      
      setMessages(prev=>[...prev,mensajeChat]);
      getDataChat(mensajeChat);
    }
  },[mensajeChat])

  const checkLogin = () => {
    const url = constans.C_API_PPID+'?login';
    setLoading(true);
    UseApiService(url,{method:'GET'})
    .then(({data,error}) =>{
      if(error){        
        let err = 'Ocurrio un error: ' + error;
        console.log(err);
        toast.error(err);
        LocalStorageManager.clear();
      }
      else{
        if(data.data?.sub&&data.code>0){
          let dataResp = data.data;
          LocalStorageManager.setItem('s_islogged','true');
          LocalStorageManager.setItem('s_email',dataResp.email);
          LocalStorageManager.setItem('s_name',dataResp.given_name);
          LocalStorageManager.setItem('s_fname',dataResp.family_name);
          LocalStorageManager.setItem('s_sid',dataResp.sub);
          LocalStorageManager.setItem('s_token',dataResp.access_token);     

          LocalStorageManager.setItem('s_ppid',dataResp.ppid);
          LocalStorageManager.setItem('s_term_description',dataResp.term_description);
          LocalStorageManager.setItem('s_status',dataResp.status);
          navigate('/');     
          console.log(data.msg);
        }        

        if(data.code==0){          
          checkDataUser();
        }
      }
    })
    .catch((e)=>{
      console.log(e);
    })
    .finally((e)=>{
      setLoading(false);
    });    
  }

  const checkDataUser = () => {        
    const url = constans.C_API_PPID;
    setLoading(true);
    UseApiService(url,{method:'GET'})
    .then(({data,error}) =>{
      if(error){
        let err = 'Ocurrio un error: ' + error;
        console.log(err);
        toast.error(err);
        setPPID('');
        LocalStorageManager.removeItem('s_ppid');
      }
      else{
        setPPID(data.code);
        LocalStorageManager.setItem('s_ppid',data.ppid);
      }
    })
    .catch((e)=>{
      console.log(e);
    })
    .finally((e)=>{
      setLoading(false);
    });    
  }

  const getDataChat = (mensaje) => {  
    setLoading(true);
    if(mensaje?.texto){
      const url = constans.C_API_QUERY;
      const uid = LocalStorageManager.getItem('s_ppid') || LocalStorageManager.getItem('s_sid') || 'anonimo';
      
      const requestBody = {
        question: mensaje.texto,
        uid: uid
      };
      
      if (conversationSessionId) {
        requestBody.session_id = conversationSessionId;
      }
      
      UseApiService(url, {
        method: 'POST',
        body: requestBody,
        headers: {
          'x-api-key': process.env.REACT_APP_API_KEY,
          'Content-Type': 'application/json'
        }
      })
      .then(({data,error}) =>{
        if(error){
          let err = 'Ocurrio un error: ' + error;
          console.log(err);
          toast.error(err);
        }
        else{
          setMessages(prev=>[...prev,{texto: data, isUser: false, isStructured: true}]);

          if(data.session_id){
            setConversationSessionId(data.session_id);
            console.log('Session ID guardado:', data.session_id);
          }

          if(mensaje.texto && mensaje.texto.trim() !== ' '){
            const newHistory = {
              type: 'human',
              content: mensaje.texto
            };
            setListaHistorial(prev => [newHistory, ...prev].slice(0, 10));
          }

          if(data.articulos && data.articulos.length > 0){
            const url2 = constans.C_API_PPID+'?data='+LocalStorageManager.getItem('s_ppid');
            UseApiService(url2,{method:'GET'})
            .then(({data,error}) =>{
              if(error){
                console.log('Error al registrar interacción:', error);
              }
            })
            .catch((e)=>{
              console.log(e);
            });
          }              
        }
      })
      .catch((e)=>{
        console.log(e);
        toast.error('Error al conectar con el servidor');
      })
      .finally((e)=>{
        setLoading(false);
      });
    }   
  }

  const getDataHoy = () => {
    const url = constans.C_API_NOTICIAS+'?type=h&l='+ (Math.floor(Math.random() * (8 - 5 + 1)) + 5).toString();
    UseApiService(url,{method:'GET'})
      .then(({data,error}) =>{
        if(error){
          let err = 'Ocurrio un error: ' + error;
          console.log(err);
          toast.error(err);
        }
        else{          
          setNoticiasHoy(data.data);
          setMensajeInicial(data.title);
        }        
      })
      .catch((e)=>{
        setNoticiasHoy([]);
        setMensajeInicial('');
        console.log(e);
      });      
  }

  const openModal1 = () => {
    setIsModalOpen(true);
  };

  const openModal2 = () => {
    setIsModalOpen2(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalOpen2(false);
  };

  const handleLogin = (val) =>{    
    if(!val){
      closeModal();
      checkDataUser();
      getDataHoy();    
    }    
  }

  return (
    <>
    <div className="d-flex vh-100">      
      <div className="sidebar d-none d-md-block">
        <SidebarComponent 
          handelChangeButton={handelChangeButton} 
          listaRecientes={listaHistorial} 
          handleChange={handleChange} 
        />
      </div>

      <div className="flex-grow-1 d-flex flex-column">      
        <Navbar className="d-md-none px-3 ">
          <Button className="btn-nav-sidebar" onClick={toggleSidebar}>☰</Button>
          <div className="logo-sidebar">
           <img src="/images/logolargo.png" alt="Logo"/>            
          </div>
        </Navbar>

        <ChatComponent 
          messages={messages} 
          handleChange={handleChange} 
          noticiasHoy={noticiasHoy}
          mensajeInicial={mensajeInicial}
          loading={loading}
        />

      </div>
            
      <Offcanvas show={showSidebar} onHide={toggleSidebar} 
        className="d-md-none sidebar p-0" style={{ maxWidth: "263px" }}
      >
        <Offcanvas.Header closeButton className="py-0">
          <img src="/images/logo.png" alt="Logo" className="logo" />
        </Offcanvas.Header>
        <Offcanvas.Body className="">
          <SidebarComponent 
            handelChangeButton={handelChangeButton} 
            listaRecientes={listaHistorial} 
            handleChange={handleChange} 
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>    
    <ModalComponent isOpen={isModalOpen} close={closeModal}>
      <LoginSingle 
        title={modalTitle} 
        handleLogin={handleLogin}
      />
    </ModalComponent>
    <ModalComponent isOpen={isModalOpen2} close={closeModal}>
      <UpgradeComponent />
    </ModalComponent>
    </>
  );
}
